import { LuRefreshCcw } from 'react-icons/lu';
import ReactIcon from '../ReactIcon';
import { BigButtonProps, BigButtonWrapper, LoadingButtonWrap } from './styles';

export const BigButton = (
    props: React.ComponentProps<'button'> & BigButtonProps
) => {
    const {
        isLoading,
        cursorBlocked,
        bgColor,
        disabled,
        children,
        onClick,
        ...rest
    } = props;
    return (
        <BigButtonWrapper
            cursorBlocked={isLoading ? isLoading : cursorBlocked}
            bgColor={isLoading ? 'secondary' : bgColor}
            disabled={isLoading ? isLoading : disabled}
            onClick={cursorBlocked ? undefined : onClick}
            {...rest}
        >
            <LoadingButtonWrap>
                {!!isLoading && (
                    <div>
                        <ReactIcon Icon={LuRefreshCcw} size={'1.2rem'} />
                    </div>
                )}
                {children}
            </LoadingButtonWrap>
        </BigButtonWrapper>
    );
};
